import React from 'react';
import AccountMenu from 'components/AccountMenu/AccountMenu';
import { NavbarProps } from 'features/navbar/types';
import { NavbarLogo } from './NavbarLogo';

type MobileBottomHeaderProps = Omit<NavbarProps, 'selectedTab' | 'onTabChange' | 'navItemList'>;
export const MobileTopHeader = ({ brandLogo, onBrandLogoClick }: MobileBottomHeaderProps) => (
  <>
    <NavbarLogo brandLogo={brandLogo} onBrandLogoClick={onBrandLogoClick} />
    <AccountMenu />
  </>
);
